import React from "react";
import { Box, Button, Dialog } from "@mui/material";
import { AddRounded } from "@mui/icons-material";
import { MessageDialog } from "../../../components/message-dialog";
import { vehiclesToProductDetail } from "../../../models/vehicles.model";
import { VehiclesWithFilterNPaginationResponse as VehicleRow } from "../../../services/vehicleService";
import { ProductDetail } from "../../main/query/topic/products/product-detail";
import { AdminFilterBar, AdminPageHeader, countLabel, DataTable, EmptyState } from "../../../components/ui";
import { useVehiclePage } from "./use-vehicle-page";
import { buildVehicleColumns } from "./vehicle-columns";
import VehicleFormModal from "./components/VehicleFormModal";

export const VehiclePage = () => {
    const {
        formik,
        rowsVehicles,
        loading,
        search,
        setSearch,
        page,
        setPage,
        pageSize,
        detailOpen,
        setDetailOpen,
        selectedVehicle,
        modalOpen,
        vehicleViewModel,
        setVehicleViewModel,
        btnSaveDisabled,
        dialogModel,
        filteredRows,
        pagedRows,
        isEditing,
        handleClickEnableVehicle,
        handleClickViewVehicle,
        handleClickEditVehicle,
        openCreate,
        closeModal,
    } = useVehiclePage();

    const columns = buildVehicleColumns({
        onEdit: handleClickEditVehicle,
        onView: handleClickViewVehicle,
        onToggle: handleClickEnableVehicle,
    });

    return (
        <Box sx={{ width: "100%", p: { xs: "18px 16px 24px", md: 4 } }}>
            <AdminPageHeader
                title="Veículos"
                subtitle="Bases e formas farmacêuticas disponíveis."
                action={
                    <Button
                        variant="contained"
                        startIcon={<AddRounded />}
                        onClick={openCreate}
                        sx={{ height: 44, borderRadius: "12px", fontWeight: 600, flexShrink: 0 }}
                    >
                        Novo veículo
                    </Button>
                }
            />

            <AdminFilterBar
                search={search}
                onSearch={(v) => {
                    setSearch(v);
                    setPage(1);
                }}
                placeholder="Buscar veículo..."
                count={countLabel(filteredRows.length, rowsVehicles.length)}
            />

            <DataTable<VehicleRow>
                columns={columns}
                rows={pagedRows}
                rowKey={(row) => String(row.id)}
                loading={loading}
                page={page}
                pageSize={pageSize}
                totalRows={filteredRows.length}
                onPageChange={setPage}
                countLabel={countLabel(filteredRows.length, rowsVehicles.length)}
                minWidth={640}
                emptyState={
                    <EmptyState
                        title="Nenhum veículo encontrado"
                        description={search ? "Tente um termo diferente na busca." : "Cadastre um novo veículo para começar."}
                        actionLabel={search ? undefined : "Novo veículo"}
                        onAction={search ? undefined : openCreate}
                    />
                }
            />

            {/* Detail dialog (ProductDetail — UNTOUCHED) */}
            <Dialog open={detailOpen} onClose={() => setDetailOpen(false)}>
                <ProductDetail detail={vehiclesToProductDetail(selectedVehicle)} onClose={() => setDetailOpen(false)} />
            </Dialog>

            <VehicleFormModal
                open={modalOpen}
                onClose={closeModal}
                isEditing={isEditing}
                btnSaveDisabled={btnSaveDisabled}
                formik={formik}
                vehicleViewModel={vehicleViewModel}
                setVehicleViewModel={setVehicleViewModel}
            />

            <MessageDialog
                emoji={dialogModel.emoji}
                open={dialogModel.open}
                title={dialogModel.title}
                message={dialogModel.message}
                onConfirm={dialogModel.onConfirm}
                confirmButtonText={dialogModel.confirmButtonText}
            />
        </Box>
    );
};
